import { useState, useEffect, useCallback } from "react";

/* ─────────────────────────────────────────────
   MOCK DATA & HELPERS
───────────────────────────────────────────── */
const AIRPORTS = [
  { code: "WAW", city: "Warszawa", country: "PL" },
  { code: "KRK", city: "Kraków", country: "PL" },
  { code: "WRO", city: "Wrocław", country: "PL" },
  { code: "GDN", city: "Gdańsk", country: "PL" },
  { code: "KTW", city: "Katowice", country: "PL" },
  { code: "POZ", city: "Poznań", country: "PL" },
  { code: "BCN", city: "Barcelona", country: "ES" },
  { code: "MAD", city: "Madryt", country: "ES" },
  { code: "PMI", city: "Majorka", country: "ES" },
  { code: "ROM", city: "Rzym", country: "IT" },
  { code: "FCO", city: "Rzym Fiumicino", country: "IT" },
  { code: "MXP", city: "Mediolan", country: "IT" },
  { code: "CDG", city: "Paryż", country: "FR" },
  { code: "AMS", city: "Amsterdam", country: "NL" },
  { code: "LGW", city: "Londyn Gatwick", country: "GB" },
  { code: "STN", city: "Londyn Stansted", country: "GB" },
  { code: "ATH", city: "Ateny", country: "GR" },
  { code: "HER", city: "Heraklion (Kreta)", country: "GR" },
  { code: "SKG", city: "Saloniki", country: "GR" },
  { code: "DUB", city: "Dublin", country: "IE" },
  { code: "LIS", city: "Lizbona", country: "PT" },
  { code: "FAO", city: "Algarve (Faro)", country: "PT" },
  { code: "PRG", city: "Praga", country: "CZ" },
  { code: "BUD", city: "Budapeszt", country: "HU" },
  { code: "VIE", city: "Wiedeń", country: "AT" },
  { code: "DXB", city: "Dubaj", country: "AE" },
  { code: "TFS", city: "Teneryfa", country: "ES" },
  { code: "LPA", city: "Gran Canaria", country: "ES" },
  { code: "ACE", city: "Lanzarote", country: "ES" },
  { code: "AGA", city: "Agadir", country: "MA" },
  { code: "RAK", city: "Marrakesz", country: "MA" },
  { code: "TUN", city: "Tunis", country: "TN" },
  { code: "OPO", city: "Porto", country: "PT" },
  { code: "BRU", city: "Bruksela", country: "BE" },
  { code: "ZRH", city: "Zurych", country: "CH" },
  { code: "CPH", city: "Kopenhaga", country: "DK" },
  { code: "OSL", city: "Oslo", country: "NO" },
  { code: "ARN", city: "Sztokholm", country: "SE" },
  { code: "HEL", city: "Helsinki", country: "FI" },
  { code: "IST", city: "Stambuł", country: "TR" },
  { code: "AYT", city: "Antalya", country: "TR" },
  { code: "BJV", city: "Bodrum", country: "TR" },
  { code: "ADB", city: "Izmir", country: "TR" },
  { code: "SSH", city: "Sharm el-Sheikh", country: "EG" },
  { code: "HRG", city: "Hurghada", country: "EG" },
  { code: "LCA", city: "Larnaka (Cypr)", country: "CY" },
  { code: "PFO", city: "Pafos (Cypr)", country: "CY" },
  { code: "RHO", city: "Rodos", country: "GR" },
  { code: "CFU", city: "Korfu", country: "GR" },
  { code: "ZTH", city: "Zakynthos", country: "GR" },
];

const AIRLINES = [
  { code: "FR", name: "Ryanair", logo: "🟡" },
  { code: "W6", name: "Wizz Air", logo: "🟣" },
  { code: "LO", name: "LOT", logo: "🔵" },
  { code: "U2", name: "easyJet", logo: "🟠" },
  { code: "VY", name: "Vueling", logo: "🟡" },
  { code: "TP", name: "TAP Air Portugal", logo: "🟢" },
];

const HOTEL_CHAINS = ["Hilton", "Marriott", "Accor", "Best Western", "ibis", "Melia", "NH Hotels", "Radisson", "Holiday Inn", "Aparthotel"];

function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
function fmtDate(d) {
  return new Date(d).toLocaleDateString("pl-PL", { day: "2-digit", month: "short", year: "numeric" });
}
function addDays(d, n) {
  const r = new Date(d); r.setDate(r.getDate() + n); return r.toISOString().split("T")[0];
}

const today = new Date().toISOString().split("T")[0];

function generateFlights(from, to, date, count = 8) {
  return Array.from({ length: count }, (_, i) => {
    const airline = pick(AIRLINES);
    const depH = rand(5, 22), depM = pick([0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]);
    const dur = rand(90, 300);
    const arrH = Math.floor((depH * 60 + depM + dur) / 60) % 24;
    const arrM = (depH * 60 + depM + dur) % 60;
    const price = rand(39, 399);
    const stops = rand(0, 1);
    return {
      id: `FL-${i}-${Date.now()}`,
      airline,
      flightNo: `${airline.code}${rand(100, 9999)}`,
      from, to, date,
      dep: `${String(depH).padStart(2, "0")}:${String(depM).padStart(2, "0")}`,
      arr: `${String(arrH).padStart(2, "0")}:${String(arrM).padStart(2, "0")}`,
      duration: `${Math.floor(dur / 60)}h ${dur % 60}min`,
      price,
      stops,
      seats: rand(1, 30),
      baggage: pick([true, false]),
      class: "economy",
    };
  }).sort((a, b) => a.price - b.price);
}

function generateHotels(city, checkin, checkout, count = 10) {
  const nights = Math.max(1, Math.round((new Date(checkout) - new Date(checkin)) / 86400000));
  return Array.from({ length: count }, (_, i) => {
    const stars = rand(2, 5);
    const pricePerNight = rand(40, 450);
    const rating = (rand(65, 99) / 10).toFixed(1);
    const reviews = rand(50, 4200);
    const chain = rand(0, 3) > 2 ? pick(HOTEL_CHAINS) : null;
    const amenities = [];
    if (rand(0, 1)) amenities.push("WiFi");
    if (rand(0, 1)) amenities.push("Basen");
    if (rand(0, 1)) amenities.push("Spa");
    if (rand(0, 1)) amenities.push("Plaża");
    if (rand(0, 1)) amenities.push("Parking");
    if (rand(0, 1)) amenities.push("Śniadanie");
    return {
      id: `HT-${i}-${Date.now()}`,
      name: chain
        ? `${chain} ${city}`
        : `${pick(["Grand", "Royal", "Blue", "Sun", "Palm", "Ocean", "City", "Central", "Plaza", "Vista"])} ${pick(["Hotel", "Resort", "Aparthotel", "Inn", "Suites"])} ${city}`,
      city, checkin, checkout, nights,
      stars,
      rating: parseFloat(rating),
      reviews,
      pricePerNight,
      totalPrice: pricePerNight * nights,
      amenities,
      board: pick(["Bez wyżywienia", "Śniadanie", "Półpension", "All-inclusive"]),
      cancelFree: rand(0, 1) === 1,
      distanceCenter: (rand(1, 80) / 10).toFixed(1),
    };
  }).sort((a, b) => a.totalPrice - b.totalPrice);
}

/* ─────────────────────────────────────────────
   STYLE CONSTANTS
───────────────────────────────────────────── */
const C = {
  bg: "#05080F",
  surface: "#0C1120",
  surfaceHover: "#111827",
  border: "#1C2A3A",
  accent: "#00D4FF",
  accentDim: "#00D4FF22",
  accentHover: "#33DDFF",
  gold: "#FFB800",
  goldDim: "#FFB80022",
  green: "#00E676",
  greenDim: "#00E67622",
  red: "#FF4757",
  text: "#E8F4FD",
  textMid: "#8BA7C0",
  textDim: "#3D5568",
  gradient: "linear-gradient(135deg, #00D4FF 0%, #0066FF 100%)",
};

const font = { display: "'Playfair Display', Georgia, serif", body: "'DM Sans', 'Segoe UI', sans-serif" };

/* ─────────────────────────────────────────────
   SUB COMPONENTS
───────────────────────────────────────────── */
function Stars({ n }) {
  return <span>{Array.from({ length: 5 }, (_, i) => (
    <span key={i} style={{ color: i < n ? C.gold : C.textDim, fontSize: 12 }}>★</span>
  ))}</span>;
}

function Badge({ children, color = C.accent }) {
  return (
    <span style={{
      background: color + "22", color, border: `1px solid ${color}44`,
      borderRadius: 4, fontSize: 11, padding: "2px 8px", fontFamily: font.body,
      letterSpacing: "0.05em", fontWeight: 600,
    }}>{children}</span>
  );
}

function Btn({ children, onClick, variant = "primary", size = "md", disabled = false, style: s = {} }) {
  const base = {
    fontFamily: font.body, cursor: disabled ? "not-allowed" : "pointer",
    border: "none", borderRadius: 6, fontWeight: 600, transition: "all 0.2s",
    opacity: disabled ? 0.5 : 1,
    fontSize: size === "sm" ? 13 : size === "lg" ? 16 : 14,
    padding: size === "sm" ? "7px 14px" : size === "lg" ? "14px 28px" : "10px 20px",
  };
  const variants = {
    primary: { background: C.gradient, color: "#fff" },
    secondary: { background: C.surface, color: C.text, border: `1px solid ${C.border}` },
    ghost: { background: "transparent", color: C.accent, border: `1px solid ${C.accent}44` },
    danger: { background: C.red + "22", color: C.red, border: `1px solid ${C.red}44` },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{ ...base, ...variants[variant], ...s }}>
      {children}
    </button>
  );
}

function Input({ label, value, onChange, type = "text", placeholder, style: s = {}, options, min, max }) {
  const inputStyle = {
    width: "100%", background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: 6, color: C.text, fontFamily: font.body, fontSize: 14,
    padding: "10px 14px", outline: "none", boxSizing: "border-box",
    transition: "border-color 0.2s",
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, ...s }}>
      {label && <label style={{ fontSize: 12, color: C.textMid, letterSpacing: "0.05em", fontFamily: font.body }}>{label}</label>}
      {type === "select" ? (
        <select value={value} onChange={e => onChange(e.target.value)} style={{ ...inputStyle }}>
          {options.map(o => <option key={o.value || o} value={o.value || o}>{o.label || o}</option>)}
        </select>
      ) : type === "textarea" ? (
        <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
          style={{ ...inputStyle, minHeight: 80, resize: "vertical" }} />
      ) : (
        <input type={type} value={value} onChange={e => onChange(e.target.value)}
          placeholder={placeholder} min={min} max={max}
          style={inputStyle} />
      )}
    </div>
  );
}

function Toggle({ value, onChange, label }) {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", userSelect: "none" }}>
      <div onClick={() => onChange(!value)} style={{
        width: 44, height: 24, borderRadius: 12,
        background: value ? C.accent : C.border,
        position: "relative", transition: "background 0.2s",
        flexShrink: 0,
      }}>
        <div style={{
          position: "absolute", top: 3, left: value ? 23 : 3,
          width: 18, height: 18, borderRadius: "50%", background: "#fff",
          transition: "left 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.4)",
        }} />
      </div>
      {label && <span style={{ fontSize: 14, color: C.textMid, fontFamily: font.body }}>{label}</span>}
    </label>
  );
}

function Card({ children, style: s = {}, glow = false }) {
  return (
    <div style={{
      background: C.surface, border: `1px solid ${C.border}`,
      borderRadius: 12, padding: 20,
      boxShadow: glow ? `0 0 30px ${C.accent}15` : "0 2px 8px rgba(0,0,0,0.3)",
      ...s,
    }}>
      {children}
    </div>
  );
}

/* ─────────────────────────────────────────────
   FLIGHT CARD
───────────────────────────────────────────── */
function FlightCard({ flight, adminConfig, onBook }) {
  const fromAirport = AIRPORTS.find(a => a.code === flight.from) || { city: flight.from };
  const toAirport = AIRPORTS.find(a => a.code === flight.to) || { city: flight.to };
  const finalPrice = Math.round(flight.price * (adminConfig.priceMarkupFlight / 100 + 1));
  const affLink = adminConfig.affiliateLinks?.skyscanner || "https://skyscanner.com";

  return (
    <Card style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        {/* Airline */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, width: 140, flexShrink: 0 }}>
          <span style={{ fontSize: 22 }}>{flight.airline.logo}</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: C.text, fontFamily: font.body }}>{flight.airline.name}</div>
            <div style={{ fontSize: 11, color: C.textMid }}>{flight.flightNo}</div>
          </div>
        </div>

        {/* Route */}
        <div style={{ display: "flex", alignItems: "center", gap: 16, flex: 1 }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: C.text, fontFamily: font.display }}>{flight.dep}</div>
            <div style={{ fontSize: 12, color: C.textMid }}>{flight.from}</div>
            <div style={{ fontSize: 11, color: C.textDim }}>{fromAirport.city}</div>
          </div>
          <div style={{ flex: 1, textAlign: "center" }}>
            <div style={{ fontSize: 11, color: C.textMid }}>{flight.duration}</div>
            <div style={{ height: 1, background: C.border, position: "relative", margin: "6px 0" }}>
              <div style={{ position: "absolute", right: -4, top: -4, color: C.accent, fontSize: 10 }}>▶</div>
            </div>
            {flight.stops === 0
              ? <Badge color={C.green}>Bezpośredni</Badge>
              : <Badge color={C.gold}>{flight.stops} przesiadka</Badge>}
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: C.text, fontFamily: font.display }}>{flight.arr}</div>
            <div style={{ fontSize: 12, color: C.textMid }}>{flight.to}</div>
            <div style={{ fontSize: 11, color: C.textDim }}>{toAirport.city}</div>
          </div>
        </div>

        {/* Price & CTA */}
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          {flight.seats <= 5 && <div style={{ fontSize: 11, color: C.red, marginBottom: 4 }}>⚡ Zostało {flight.seats} miejsc!</div>}
          {flight.baggage && <div style={{ fontSize: 11, color: C.green, marginBottom: 4 }}>✓ Bagaż w cenie</div>}
          <div style={{ fontSize: 28, fontWeight: 800, color: C.accent, fontFamily: font.display, lineHeight: 1 }}>
            {finalPrice} zł
          </div>
          <div style={{ fontSize: 11, color: C.textMid, marginBottom: 8 }}>/ osoba</div>
          <a href={affLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <Btn size="sm">Kupuj →</Btn>
          </a>
        </div>
      </div>
    </Card>
  );
}

/* ─────────────────────────────────────────────
   HOTEL CARD
───────────────────────────────────────────── */
function HotelCard({ hotel, adminConfig }) {
  const finalPrice = Math.round(hotel.totalPrice * (adminConfig.priceMarkupHotel / 100 + 1));
  const affLink = adminConfig.affiliateLinks?.booking || "https://booking.com";

  return (
    <Card style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {/* Hotel info */}
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 700, color: C.text, fontFamily: font.display, marginBottom: 4 }}>{hotel.name}</div>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
                <Stars n={hotel.stars} />
                <span style={{ fontSize: 13, color: C.textMid }}>{hotel.city}</span>
                <span style={{ fontSize: 12, color: C.textDim }}>· {hotel.distanceCenter} km od centrum</span>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ background: C.accent, color: C.bg, borderRadius: 8, padding: "6px 12px", fontWeight: 800, fontSize: 18, fontFamily: font.display }}>
                {hotel.rating}
              </div>
              <div style={{ fontSize: 11, color: C.textMid, marginTop: 2 }}>{hotel.reviews} opinii</div>
            </div>
          </div>

          {/* Amenities */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
            {hotel.amenities.map(a => <Badge key={a} color={C.textMid}>{a}</Badge>)}
            <Badge color={C.gold}>{hotel.board}</Badge>
            {hotel.cancelFree && <Badge color={C.green}>Darmowe odwołanie</Badge>}
          </div>

          {/* Dates */}
          <div style={{ fontSize: 12, color: C.textMid }}>
            {fmtDate(hotel.checkin)} → {fmtDate(hotel.checkout)} · {hotel.nights} {hotel.nights === 1 ? "noc" : hotel.nights < 5 ? "noce" : "nocy"}
          </div>
        </div>

        {/* Price */}
        <div style={{ textAlign: "right", flexShrink: 0, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 13, color: C.textMid }}>od {Math.round(hotel.pricePerNight * (adminConfig.priceMarkupHotel / 100 + 1))} zł/noc</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: C.gold, fontFamily: font.display, lineHeight: 1 }}>
              {finalPrice} zł
            </div>
            <div style={{ fontSize: 11, color: C.textMid, marginBottom: 12 }}>łącznie za pobyt</div>
          </div>
          <a href={affLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <Btn size="sm" variant="ghost">Rezerwuj →</Btn>
          </a>
        </div>
      </div>
    </Card>
  );
}

/* ─────────────────────────────────────────────
   INSURANCE WIDGET
───────────────────────────────────────────── */
function InsuranceWidget({ adminConfig, nights, pax }) {
  const [selected, setSelected] = useState(null);
  const link = adminConfig.affiliateLinks?.insurance || "#";
  const plans = [
    { id: "basic", name: "Podstawowe", price: 29 * pax, cover: "Koszty leczenia do 50 000 €", color: C.textMid },
    { id: "standard", name: "Standardowe", price: 59 * pax, cover: "Leczenie + OC + bagaż", color: C.accent, recommended: true },
    { id: "premium", name: "Premium", price: 99 * pax, cover: "All-risk + sporty + anulacja", color: C.gold },
  ];
  return (
    <Card style={{ marginTop: 24 }} glow>
      <div style={{ fontSize: 11, letterSpacing: "0.2em", color: C.accent, textTransform: "uppercase", marginBottom: 8, fontFamily: font.body }}>🛡 Ubezpieczenie podróżne</div>
      <div style={{ fontSize: 14, color: C.textMid, marginBottom: 16, fontFamily: font.body }}>
        Wybierz ochronę na {nights} {nights === 1 ? "dobę" : nights < 5 ? "doby" : "dób"} dla {pax} {pax === 1 ? "osoby" : "osób"}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {plans.map(p => (
          <div key={p.id} onClick={() => setSelected(p.id)} style={{
            border: `2px solid ${selected === p.id ? p.color : C.border}`,
            borderRadius: 10, padding: 14, cursor: "pointer", transition: "all 0.2s",
            background: selected === p.id ? p.color + "11" : C.bg,
            position: "relative",
          }}>
            {p.recommended && <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: C.accent, color: C.bg, fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 4, whiteSpace: "nowrap" }}>POLECANE</div>}
            <div style={{ fontSize: 14, fontWeight: 700, color: p.color, fontFamily: font.body, marginBottom: 4 }}>{p.name}</div>
            <div style={{ fontSize: 11, color: C.textMid, marginBottom: 8 }}>{p.cover}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.text, fontFamily: font.display }}>{p.price} zł</div>
          </div>
        ))}
      </div>
      {selected && (
        <div style={{ marginTop: 16, textAlign: "right" }}>
          <a href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            <Btn>Kup ubezpieczenie →</Btn>
          </a>
        </div>
      )}
    </Card>
  );
}

/* ─────────────────────────────────────────────
   ADMIN PANEL
───────────────────────────────────────────── */
function AdminPanel({ config, setConfig, onClose }) {
  const [cfg, setCfg] = useState({ ...config });
  const [activeTab, setActiveTab] = useState("general");

  const save = () => { setConfig(cfg); onClose(); };

  const tabs = [
    { id: "general", label: "Ogólne", icon: "⚙" },
    { id: "search", label: "Wyszukiwarka", icon: "🔍" },
    { id: "affiliate", label: "Afiliacja", icon: "💰" },
    { id: "display", label: "Wyświetlanie", icon: "🎨" },
    { id: "seo", label: "SEO & Meta", icon: "📈" },
    { id: "alerts", label: "Alerty", icon: "🔔" },
    { id: "insurance", label: "Ubezpieczenia", icon: "🛡" },
    { id: "ads", label: "Reklamy", icon: "📢" },
  ];

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 1000,
      display: "flex", alignItems: "stretch", justifyContent: "flex-end",
    }}>
      <div style={{
        width: "min(700px, 95vw)", background: C.bg, borderLeft: `1px solid ${C.border}`,
        display: "flex", flexDirection: "column", overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: C.text, fontFamily: font.display }}>Panel Administratora</div>
            <div style={{ fontSize: 12, color: C.textMid }}>Konfiguracja portalu wycieczek</div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn onClick={save}>💾 Zapisz</Btn>
            <Btn variant="secondary" onClick={onClose}>✕</Btn>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", overflowX: "auto", borderBottom: `1px solid ${C.border}`, flexShrink: 0, background: C.surface }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
              background: "none", border: "none", padding: "12px 16px", cursor: "pointer",
              fontFamily: font.body, fontSize: 12, whiteSpace: "nowrap",
              color: activeTab === t.id ? C.accent : C.textMid,
              borderBottom: activeTab === t.id ? `2px solid ${C.accent}` : "2px solid transparent",
            }}>
              {t.icon} {t.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>

          {activeTab === "general" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Input label="Nazwa portalu" value={cfg.siteName} onChange={v => setCfg({ ...cfg, siteName: v })} />
              <Input label="Tagline / slogan" value={cfg.tagline} onChange={v => setCfg({ ...cfg, tagline: v })} />
              <Input label="Adres e-mail kontaktowy" value={cfg.contactEmail} onChange={v => setCfg({ ...cfg, contactEmail: v })} type="email" />
              <Input label="Waluta" value={cfg.currency} onChange={v => setCfg({ ...cfg, currency: v })}
                type="select" options={[{ value: "PLN", label: "PLN — Polski złoty" }, { value: "EUR", label: "EUR — Euro" }, { value: "USD", label: "USD — Dolar" }]} />
              <Input label="Język portalu" value={cfg.language} onChange={v => setCfg({ ...cfg, language: v })}
                type="select" options={[{ value: "pl", label: "Polski" }, { value: "en", label: "English" }, { value: "de", label: "Deutsch" }]} />
              <Toggle label="Tryb konserwacji (portal offline)" value={cfg.maintenanceMode} onChange={v => setCfg({ ...cfg, maintenanceMode: v })} />
              <Toggle label="Pokaż licznik odwiedzin" value={cfg.showVisitorCount} onChange={v => setCfg({ ...cfg, showVisitorCount: v })} />
            </div>
          )}

          {activeTab === "search" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ fontSize: 12, color: C.textMid, background: C.accentDim, border: `1px solid ${C.accent}44`, borderRadius: 8, padding: 12 }}>
                ℹ️ Portal używa symulowanych danych. W wersji produkcyjnej podłącz klucze API Skyscanner / Amadeus / Booking.com.
              </div>
              <Input label="Domyślne miasto wylotu" value={cfg.defaultOrigin} onChange={v => setCfg({ ...cfg, defaultOrigin: v })}
                type="select" options={AIRPORTS.filter(a => a.country === "PL").map(a => ({ value: a.code, label: `${a.city} (${a.code})` }))} />
              <Input label="Maks. liczba wyników lotów" value={cfg.maxFlights} onChange={v => setCfg({ ...cfg, maxFlights: parseInt(v) })} type="number" min={3} max={50} />
              <Input label="Maks. liczba wyników hoteli" value={cfg.maxHotels} onChange={v => setCfg({ ...cfg, maxHotels: parseInt(v) })} type="number" min={3} max={50} />
              <Input label="Domyślna liczba nocy" value={cfg.defaultNights} onChange={v => setCfg({ ...cfg, defaultNights: parseInt(v) })} type="number" min={1} max={30} />
              <Input label="Domyślna liczba pasażerów" value={cfg.defaultPax} onChange={v => setCfg({ ...cfg, defaultPax: parseInt(v) })} type="number" min={1} max={10} />
              <Toggle label="Pokaż tylko loty bezpośrednie domyślnie" value={cfg.directOnly} onChange={v => setCfg({ ...cfg, directOnly: v })} />
              <Toggle label="Auto-wyszukiwanie przy wejściu na stronę" value={cfg.autoSearch} onChange={v => setCfg({ ...cfg, autoSearch: v })} />
              <Input label="Odświeżaj wyniki co (minuty, 0 = wyłączone)" value={cfg.refreshInterval} onChange={v => setCfg({ ...cfg, refreshInterval: parseInt(v) })} type="number" min={0} max={60} />
            </div>
          )}

          {activeTab === "affiliate" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.text, fontFamily: font.body }}>Linki afiliacyjne</div>
              <Input label="Link Skyscanner (loty)" value={cfg.affiliateLinks.skyscanner} onChange={v => setCfg({ ...cfg, affiliateLinks: { ...cfg.affiliateLinks, skyscanner: v } })} placeholder="https://skyscanner.com/?ref=TWÓJ_ID" />
              <Input label="Link Booking.com (hotele)" value={cfg.affiliateLinks.booking} onChange={v => setCfg({ ...cfg, affiliateLinks: { ...cfg.affiliateLinks, booking: v } })} placeholder="https://booking.com/?aid=TWÓJ_ID" />
              <Input label="Link ubezpieczenia" value={cfg.affiliateLinks.insurance} onChange={v => setCfg({ ...cfg, affiliateLinks: { ...cfg.affiliateLinks, insurance: v } })} placeholder="https://ubezpieczyciel.pl/?ref=TWÓJ_ID" />
              <Input label="Link Kiwi.com (alternatywa lotów)" value={cfg.affiliateLinks.kiwi} onChange={v => setCfg({ ...cfg, affiliateLinks: { ...cfg.affiliateLinks, kiwi: v } })} placeholder="https://kiwi.com/?ref=TWÓJ_ID" />
              <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 20 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: C.text, fontFamily: font.body, marginBottom: 16 }}>Marże cenowe (wyświetlane ceny)</div>
                <Input label={`Narzut na loty: ${cfg.priceMarkupFlight}%`} value={cfg.priceMarkupFlight} onChange={v => setCfg({ ...cfg, priceMarkupFlight: parseInt(v) })} type="number" min={0} max={50} />
                <div style={{ height: 16 }} />
                <Input label={`Narzut na hotele: ${cfg.priceMarkupHotel}%`} value={cfg.priceMarkupHotel} onChange={v => setCfg({ ...cfg, priceMarkupHotel: parseInt(v) })} type="number" min={0} max={50} />
              </div>
              <Toggle label="Otwieraj linki afiliacyjne w nowej karcie" value={cfg.openInNewTab} onChange={v => setCfg({ ...cfg, openInNewTab: v })} />
            </div>
          )}

          {activeTab === "display" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Input label="Kolor akcentu (hex)" value={cfg.accentColor} onChange={v => setCfg({ ...cfg, accentColor: v })} placeholder="#00D4FF" />
              <Input label="Motyw" value={cfg.theme} onChange={v => setCfg({ ...cfg, theme: v })}
                type="select" options={[{ value: "dark", label: "Ciemny" }, { value: "light", label: "Jasny" }]} />
              <Input label="Sortowanie lotów domyślnie" value={cfg.flightSort} onChange={v => setCfg({ ...cfg, flightSort: v })}
                type="select" options={[
                  { value: "price_asc", label: "Cena rosnąco" },
                  { value: "price_desc", label: "Cena malejąco" },
                  { value: "duration", label: "Czas lotu" },
                  { value: "departure", label: "Godzina wylotu" },
                ]} />
              <Input label="Sortowanie hoteli domyślnie" value={cfg.hotelSort} onChange={v => setCfg({ ...cfg, hotelSort: v })}
                type="select" options={[
                  { value: "price_asc", label: "Cena rosnąco" },
                  { value: "rating_desc", label: "Ocena malejąco" },
                  { value: "stars_desc", label: "Gwiazdki malejąco" },
                ]} />
              <Toggle label="Pokaż widget ubezpieczenia" value={cfg.showInsurance} onChange={v => setCfg({ ...cfg, showInsurance: v })} />
              <Toggle label="Pokaż banner powitalny" value={cfg.showBanner} onChange={v => setCfg({ ...cfg, showBanner: v })} />
              <Toggle label="Pokazuj liczbę miejsc w locie" value={cfg.showSeats} onChange={v => setCfg({ ...cfg, showSeats: v })} />
              <Toggle label="Animowane ładowanie wyników" value={cfg.animatedResults} onChange={v => setCfg({ ...cfg, animatedResults: v })} />
            </div>
          )}

          {activeTab === "seo" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Input label="Meta tytuł strony" value={cfg.metaTitle} onChange={v => setCfg({ ...cfg, metaTitle: v })} />
              <Input label="Meta opis (description)" value={cfg.metaDesc} onChange={v => setCfg({ ...cfg, metaDesc: v })} type="textarea" />
              <Input label="Słowa kluczowe (oddziel przecinkami)" value={cfg.metaKeywords} onChange={v => setCfg({ ...cfg, metaKeywords: v })} type="textarea" />
              <Input label="Google Analytics ID" value={cfg.gaId} onChange={v => setCfg({ ...cfg, gaId: v })} placeholder="G-XXXXXXXXXX" />
              <Input label="Facebook Pixel ID" value={cfg.fbPixelId} onChange={v => setCfg({ ...cfg, fbPixelId: v })} placeholder="123456789" />
              <Toggle label="Sitemap XML (auto-generowany)" value={cfg.sitemap} onChange={v => setCfg({ ...cfg, sitemap: v })} />
              <Toggle label="Canonical URL" value={cfg.canonical} onChange={v => setCfg({ ...cfg, canonical: v })} />
            </div>
          )}

          {activeTab === "alerts" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Toggle label="Alerty e-mail o tanich lotach" value={cfg.emailAlerts} onChange={v => setCfg({ ...cfg, emailAlerts: v })} />
              <Toggle label="Alerty push (web notifications)" value={cfg.pushAlerts} onChange={v => setCfg({ ...cfg, pushAlerts: v })} />
              <Input label="Próg 'taniej oferty' (% poniżej średniej)" value={cfg.dealThreshold} onChange={v => setCfg({ ...cfg, dealThreshold: parseInt(v) })} type="number" min={5} max={70} />
              <Input label="Etykieta alertu cenowego" value={cfg.hotDealLabel} onChange={v => setCfg({ ...cfg, hotDealLabel: v })} placeholder="np. 🔥 HOT DEAL" />
              <Input label="Mailchimp API Key" value={cfg.mailchimpKey} onChange={v => setCfg({ ...cfg, mailchimpKey: v })} placeholder="klucz API newslettera" />
              <Input label="Tekst zachęty do zapisu na newsletter" value={cfg.newsletterCta} onChange={v => setCfg({ ...cfg, newsletterCta: v })} type="textarea" />
            </div>
          )}

          {activeTab === "insurance" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Toggle label="Pokaż widget ubezpieczenia" value={cfg.showInsurance} onChange={v => setCfg({ ...cfg, showInsurance: v })} />
              <Toggle label="Wyróżnij plan 'Standardowy' jako polecany" value={cfg.insuranceHighlight} onChange={v => setCfg({ ...cfg, insuranceHighlight: v })} />
              <Input label="Prowizja ubezpieczenia (%)" value={cfg.insuranceCommission} onChange={v => setCfg({ ...cfg, insuranceCommission: parseInt(v) })} type="number" min={5} max={50} />
              <Input label="Cena planu Podstawowego (zł/osoba)" value={cfg.insurancePriceBasic} onChange={v => setCfg({ ...cfg, insurancePriceBasic: parseInt(v) })} type="number" min={5} max={200} />
              <Input label="Cena planu Standardowego (zł/osoba)" value={cfg.insurancePriceStd} onChange={v => setCfg({ ...cfg, insurancePriceStd: parseInt(v) })} type="number" min={5} max={200} />
              <Input label="Cena planu Premium (zł/osoba)" value={cfg.insurancePricePrem} onChange={v => setCfg({ ...cfg, insurancePricePrem: parseInt(v) })} type="number" min={5} max={200} />
              <Input label="Dostawca ubezpieczenia (wyświetlana nazwa)" value={cfg.insuranceProvider} onChange={v => setCfg({ ...cfg, insuranceProvider: v })} />
            </div>
          )}

          {activeTab === "ads" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <Toggle label="Reklamy Google AdSense" value={cfg.adsenseEnabled} onChange={v => setCfg({ ...cfg, adsenseEnabled: v })} />
              <Input label="Google AdSense Publisher ID" value={cfg.adsenseId} onChange={v => setCfg({ ...cfg, adsenseId: v })} placeholder="ca-pub-XXXXXXXXXX" />
              <Toggle label="Baner reklamowy nad wynikami" value={cfg.adsBannerTop} onChange={v => setCfg({ ...cfg, adsBannerTop: v })} />
              <Toggle label="Baner reklamowy pod wynikami" value={cfg.adsBannerBottom} onChange={v => setCfg({ ...cfg, adsBannerBottom: v })} />
              <Toggle label="Reklama między lotami (co N wyników)" value={cfg.adsInline} onChange={v => setCfg({ ...cfg, adsInline: v })} />
              <Input label="Reklama inline co ile wyników" value={cfg.adsInlineFreq} onChange={v => setCfg({ ...cfg, adsInlineFreq: parseInt(v) })} type="number" min={2} max={20} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   STATS BAR
───────────────────────────────────────────── */
function StatsBar() {
  const [count, setCount] = useState(rand(1200, 2800));
  useEffect(() => {
    const i = setInterval(() => setCount(c => c + rand(0, 3)), 4000);
    return () => clearInterval(i);
  }, []);
  return (
    <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "8px 24px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", gap: 24, flexWrap: "wrap", justifyContent: "center" }}>
        {[
          { label: "Użytkowników online", value: count.toLocaleString("pl-PL"), color: C.green },
          { label: "Wyszukań dziś", value: (rand(45, 80) * 100).toLocaleString("pl-PL"), color: C.accent },
          { label: "Ofert aktywnych", value: rand(1200, 1800).toLocaleString("pl-PL"), color: C.gold },
          { label: "Średnia oszczędność", value: "47%", color: C.green },
        ].map((s, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontFamily: font.body }}>
            <span style={{ color: s.color, fontWeight: 700 }}>{s.value}</span>
            <span style={{ color: C.textMid }}>{s.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   MAIN APP
───────────────────────────────────────────── */
const defaultConfig = {
  siteName: "TanioLecę.pl",
  tagline: "Znajdź najtańszą wycieczkę w 30 sekund",
  contactEmail: "kontakt@taniolece.pl",
  currency: "PLN",
  language: "pl",
  maintenanceMode: false,
  showVisitorCount: true,
  defaultOrigin: "WAW",
  maxFlights: 8,
  maxHotels: 8,
  defaultNights: 7,
  defaultPax: 2,
  directOnly: false,
  autoSearch: false,
  refreshInterval: 0,
  affiliateLinks: {
    skyscanner: "https://skyscanner.com",
    booking: "https://booking.com",
    insurance: "#",
    kiwi: "https://kiwi.com",
  },
  priceMarkupFlight: 0,
  priceMarkupHotel: 0,
  openInNewTab: true,
  accentColor: "#00D4FF",
  theme: "dark",
  flightSort: "price_asc",
  hotelSort: "price_asc",
  showInsurance: true,
  showBanner: true,
  showSeats: true,
  animatedResults: true,
  metaTitle: "TanioLecę.pl — Tanie wycieczki i loty",
  metaDesc: "Wyszukaj najtańsze loty i hotele. Porównaj ceny w jednym miejscu.",
  metaKeywords: "tanie loty, tanie wycieczki, last minute, city break",
  gaId: "",
  fbPixelId: "",
  sitemap: true,
  canonical: true,
  emailAlerts: true,
  pushAlerts: false,
  dealThreshold: 30,
  hotDealLabel: "🔥 HOT DEAL",
  mailchimpKey: "",
  newsletterCta: "Zapisz się i otrzymuj alerty o tanich lotach!",
  showInsurance: true,
  insuranceHighlight: true,
  insuranceCommission: 25,
  insurancePriceBasic: 29,
  insurancePriceStd: 59,
  insurancePricePrem: 99,
  insuranceProvider: "Allianz Travel",
  adsenseEnabled: false,
  adsenseId: "",
  adsBannerTop: false,
  adsBannerBottom: false,
  adsInline: false,
  adsInlineFreq: 5,
};

export default function App() {
  const [config, setConfig] = useState(defaultConfig);
  const [adminOpen, setAdminOpen] = useState(false);
  const [view, setView] = useState("search"); // search | results
  const [loading, setLoading] = useState(false);

  // Search form
  const [origin, setOrigin] = useState(config.defaultOrigin);
  const [dest, setDest] = useState("BCN");
  const [depDate, setDepDate] = useState(addDays(today, 14));
  const [retDate, setRetDate] = useState(addDays(today, 14 + config.defaultNights));
  const [pax, setPax] = useState(config.defaultPax);
  const [directOnly, setDirectOnly] = useState(config.directOnly);
  const [maxFlightPrice, setMaxFlightPrice] = useState(500);
  const [maxHotelPrice, setMaxHotelPrice] = useState(3000);
  const [minStars, setMinStars] = useState(0);
  const [flightTab, setFlightTab] = useState("out"); // out | ret

  // Results
  const [flights, setFlights] = useState([]);
  const [retFlights, setRetFlights] = useState([]);
  const [hotels, setHotels] = useState([]);

  const nights = Math.max(1, Math.round((new Date(retDate) - new Date(depDate)) / 86400000));

  const doSearch = useCallback(() => {
    setLoading(true);
    setView("results");
    setTimeout(() => {
      const f = generateFlights(origin, dest, depDate, config.maxFlights);
      const rf = generateFlights(dest, origin, retDate, config.maxFlights);
      const h = generateHotels(AIRPORTS.find(a => a.code === dest)?.city || dest, depDate, retDate, config.maxHotels);
      setFlights(directOnly ? f.filter(x => x.stops === 0) : f);
      setRetFlights(directOnly ? rf.filter(x => x.stops === 0) : rf);
      setHotels(h);
      setLoading(false);
    }, rand(800, 1400));
  }, [origin, dest, depDate, retDate, config.maxFlights, config.maxHotels, directOnly]);

  const filteredFlights = flights.filter(f => f.price <= maxFlightPrice);
  const filteredRetFlights = retFlights.filter(f => f.price <= maxFlightPrice);
  const filteredHotels = hotels.filter(h => h.totalPrice <= maxHotelPrice && h.stars >= minStars);

  const destCity = AIRPORTS.find(a => a.code === dest)?.city || dest;
  const origCity = AIRPORTS.find(a => a.code === origin)?.city || origin;

  const airportOptions = AIRPORTS.map(a => ({ value: a.code, label: `${a.city} (${a.code}) — ${a.country}` }));

  return (
    <div style={{ background: C.bg, minHeight: "100vh", fontFamily: font.body, color: C.text }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-track { background: ${C.bg}; }
        ::-webkit-scrollbar-thumb { background: ${C.border}; border-radius: 3px; }
        select option { background: #0C1120; color: #E8F4FD; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.5; } }
      `}</style>

      {/* NAVBAR */}
      <nav style={{
        background: C.surface, borderBottom: `1px solid ${C.border}`,
        padding: "0 24px", position: "sticky", top: 0, zIndex: 100,
        display: "flex", alignItems: "center", justifyContent: "space-between", height: 60,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 24 }}>✈</span>
          <div style={{ fontSize: 20, fontWeight: 800, fontFamily: font.display, background: C.gradient, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            {config.siteName}
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          {view === "results" && (
            <Btn variant="ghost" size="sm" onClick={() => setView("search")}>← Nowe wyszukiwanie</Btn>
          )}
          <Btn size="sm" variant="secondary" onClick={() => setAdminOpen(true)}>⚙ Admin</Btn>
        </div>
      </nav>

      {config.showVisitorCount && <StatsBar />}

      {/* SEARCH VIEW */}
      {view === "search" && (
        <div>
          {/* Hero */}
          <div style={{
            background: `linear-gradient(135deg, #05080F 0%, #0A1628 50%, #05080F 100%)`,
            padding: "60px 24px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}>
            <div style={{ position: "absolute", inset: 0, backgroundImage: `radial-gradient(circle at 30% 50%, ${C.accent}08 0%, transparent 50%), radial-gradient(circle at 70% 30%, ${C.gold}08 0%, transparent 50%)`, pointerEvents: "none" }} />
            <div style={{ position: "relative", maxWidth: 700, margin: "0 auto" }}>
              <div style={{ fontSize: 13, letterSpacing: "0.3em", color: C.accent, textTransform: "uppercase", marginBottom: 12 }}>Portal wycieczek last-minute</div>
              <h1 style={{ fontSize: "clamp(28px, 5vw, 52px)", fontFamily: font.display, fontWeight: 800, lineHeight: 1.15, margin: "0 0 16px" }}>
                {config.tagline}
              </h1>
              <p style={{ fontSize: 16, color: C.textMid, maxWidth: 500, margin: "0 auto" }}>
                Porównujemy setki lotów i hoteli jednocześnie. Płacisz mniej, lecisz więcej.
              </p>
            </div>
          </div>

          {/* Search Form */}
          <div style={{ maxWidth: 900, margin: "-30px auto 40px", padding: "0 24px" }}>
            <Card glow style={{ padding: 28 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                <Input label="Skąd lecisz?" value={origin} onChange={setOrigin} type="select" options={airportOptions} />
                <Input label="Dokąd lecisz?" value={dest} onChange={setDest} type="select" options={airportOptions} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16, marginBottom: 20 }}>
                <Input label="Data wylotu" value={depDate} onChange={v => { setDepDate(v); if (v > retDate) setRetDate(addDays(v, config.defaultNights)); }} type="date" min={today} />
                <Input label="Data powrotu" value={retDate} onChange={setRetDate} type="date" min={depDate} />
                <Input label="Pasażerowie" value={pax} onChange={v => setPax(parseInt(v))} type="number" min={1} max={9} />
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <label style={{ fontSize: 12, color: C.textMid, letterSpacing: "0.05em" }}>Opcje</label>
                  <div style={{ display: "flex", alignItems: "center", height: 42 }}>
                    <Toggle label="Tylko bezpośrednie" value={directOnly} onChange={setDirectOnly} />
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, color: C.textMid }}>Maks. cena lotu: <strong style={{ color: C.accent }}>{maxFlightPrice} zł</strong></label>
                  <input type="range" min={50} max={2000} step={50} value={maxFlightPrice} onChange={e => setMaxFlightPrice(parseInt(e.target.value))}
                    style={{ width: "100%", accentColor: C.accent, marginTop: 6 }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, color: C.textMid }}>Maks. cena hotelu: <strong style={{ color: C.gold }}>{maxHotelPrice} zł</strong></label>
                  <input type="range" min={200} max={10000} step={100} value={maxHotelPrice} onChange={e => setMaxHotelPrice(parseInt(e.target.value))}
                    style={{ width: "100%", accentColor: C.gold, marginTop: 6 }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 12, color: C.textMid }}>Min. standard hotelu: <strong style={{ color: C.gold }}>{minStars}+ ★</strong></label>
                  <input type="range" min={0} max={5} step={1} value={minStars} onChange={e => setMinStars(parseInt(e.target.value))}
                    style={{ width: "100%", accentColor: C.gold, marginTop: 6 }} />
                </div>
              </div>
              <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
                <Btn size="lg" onClick={doSearch} style={{ minWidth: 260, fontSize: 16 }}>
                  🔍 Szukaj wycieczek
                </Btn>
              </div>
            </Card>
          </div>

          {/* Popular destinations */}
          <div style={{ maxWidth: 900, margin: "0 auto 60px", padding: "0 24px" }}>
            <div style={{ fontSize: 11, letterSpacing: "0.25em", color: C.textMid, textTransform: "uppercase", marginBottom: 16 }}>Popularne kierunki</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {[
                { code: "BCN", emoji: "🇪🇸", label: "Barcelona" },
                { code: "ATH", emoji: "🇬🇷", label: "Ateny" },
                { code: "LIS", emoji: "🇵🇹", label: "Lizbona" },
                { code: "PMI", emoji: "🏝", label: "Majorka" },
                { code: "AYT", emoji: "🇹🇷", label: "Antalya" },
                { code: "DXB", emoji: "🇦🇪", label: "Dubaj" },
                { code: "TFS", emoji: "🌋", label: "Teneryfa" },
                { code: "HRG", emoji: "🐠", label: "Hurghada" },
                { code: "HER", emoji: "🏛", label: "Kreta" },
                { code: "CDG", emoji: "🇫🇷", label: "Paryż" },
                { code: "IST", emoji: "🕌", label: "Stambuł" },
                { code: "LCA", emoji: "☀️", label: "Cypr" },
              ].map(d => (
                <button key={d.code} onClick={() => { setDest(d.code); }}
                  style={{
                    background: dest === d.code ? C.accentDim : C.surface,
                    border: `1px solid ${dest === d.code ? C.accent : C.border}`,
                    color: dest === d.code ? C.accent : C.textMid,
                    borderRadius: 8, padding: "8px 16px", cursor: "pointer",
                    fontSize: 14, fontFamily: font.body, transition: "all 0.2s",
                    display: "flex", alignItems: "center", gap: 6,
                  }}>
                  {d.emoji} {d.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* RESULTS VIEW */}
      {view === "results" && (
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "32px 24px" }}>

          {loading ? (
            <div style={{ textAlign: "center", padding: "80px 0" }}>
              <div style={{ width: 48, height: 48, border: `3px solid ${C.border}`, borderTop: `3px solid ${C.accent}`, borderRadius: "50%", margin: "0 auto 20px", animation: "spin 0.8s linear infinite" }} />
              <div style={{ fontSize: 18, color: C.textMid, fontFamily: font.display, fontStyle: "italic" }}>
                Przeszukujemy tysiące ofert...
              </div>
            </div>
          ) : (
            <div>
              {/* Summary */}
              <div style={{ marginBottom: 32 }}>
                <h2 style={{ fontFamily: font.display, fontSize: 28, fontWeight: 700, margin: "0 0 8px" }}>
                  {origCity} → {destCity}
                </h2>
                <div style={{ color: C.textMid, fontSize: 14, display: "flex", gap: 16, flexWrap: "wrap" }}>
                  <span>📅 {fmtDate(depDate)} – {fmtDate(retDate)}</span>
                  <span>🌙 {nights} nocy</span>
                  <span>👤 {pax} {pax === 1 ? "osoba" : pax < 5 ? "osoby" : "osób"}</span>
                  <span style={{ color: C.green }}>✈ {filteredFlights.length} lotów · 🏨 {filteredHotels.length} hoteli</span>
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
                {/* FLIGHTS */}
                <div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                    <div style={{ fontSize: 16, fontWeight: 700, fontFamily: font.display }}>Loty</div>
                    <div style={{ display: "flex", gap: 0, background: C.surface, borderRadius: 8, border: `1px solid ${C.border}`, overflow: "hidden" }}>
                      {[{ id: "out", label: "Wylot" }, { id: "ret", label: "Powrót" }].map(t => (
                        <button key={t.id} onClick={() => setFlightTab(t.id)} style={{
                          background: flightTab === t.id ? C.accent : "none",
                          color: flightTab === t.id ? C.bg : C.textMid,
                          border: "none", padding: "7px 16px", cursor: "pointer",
                          fontFamily: font.body, fontSize: 13, fontWeight: 600,
                        }}>{t.label}</button>
                      ))}
                    </div>
                  </div>

                  <div style={{ maxHeight: 600, overflowY: "auto", paddingRight: 4 }}>
                    {(flightTab === "out" ? filteredFlights : filteredRetFlights).length === 0 ? (
                      <div style={{ textAlign: "center", padding: 40, color: C.textMid }}>
                        Brak lotów spełniających kryteria. Zwiększ limit cenowy.
                      </div>
                    ) : (
                      (flightTab === "out" ? filteredFlights : filteredRetFlights).map((f, i) => (
                        <div key={f.id} style={{ animation: config.animatedResults ? `fadeIn 0.3s ease ${i * 0.05}s both` : "none" }}>
                          <FlightCard flight={f} adminConfig={config} />
                        </div>
                      ))
                    )}
                  </div>
                </div>

                {/* HOTELS */}
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, fontFamily: font.display, marginBottom: 16 }}>
                    Hotele w: {destCity}
                  </div>
                  <div style={{ maxHeight: 600, overflowY: "auto", paddingRight: 4 }}>
                    {filteredHotels.length === 0 ? (
                      <div style={{ textAlign: "center", padding: 40, color: C.textMid }}>
                        Brak hoteli spełniających kryteria.
                      </div>
                    ) : (
                      filteredHotels.map((h, i) => (
                        <div key={h.id} style={{ animation: config.animatedResults ? `fadeIn 0.3s ease ${i * 0.05}s both` : "none" }}>
                          <HotelCard hotel={h} adminConfig={config} />
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              {/* Insurance */}
              {config.showInsurance && (
                <InsuranceWidget adminConfig={config} nights={nights} pax={pax} />
              )}

              {/* Newsletter */}
              <Card style={{ marginTop: 24, background: `linear-gradient(135deg, ${C.accent}11, ${C.goldDim})`, border: `1px solid ${C.accent}33` }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 700, fontFamily: font.display, marginBottom: 4 }}>📧 {config.newsletterCta}</div>
                    <div style={{ fontSize: 13, color: C.textMid }}>Bądź pierwszy, gdy pojawi się okazja do {destCity}!</div>
                  </div>
                  <div style={{ display: "flex", gap: 10 }}>
                    <input placeholder="Twój e-mail" style={{
                      background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6,
                      padding: "10px 14px", color: C.text, fontFamily: font.body, fontSize: 14, outline: "none",
                    }} />
                    <Btn>Zapisz się</Btn>
                  </div>
                </div>
              </Card>
            </div>
          )}
        </div>
      )}

      {/* ADMIN PANEL */}
      {adminOpen && <AdminPanel config={config} setConfig={setConfig} onClose={() => setAdminOpen(false)} />}

      {/* FOOTER */}
      <footer style={{ borderTop: `1px solid ${C.border}`, padding: "24px", textAlign: "center", marginTop: 60 }}>
        <div style={{ fontSize: 12, color: C.textDim }}>
          © 2025 {config.siteName} · {config.contactEmail} · Wszystkie linki to linki afiliacyjne
        </div>
      </footer>
    </div>
  );
}